import { createSelector } from 'reselect'
import * as CardStatusRoles from 'const/CardStatusRoles'
import sequenceDateConflictTesters from 'const/sequenceDateConflictTesters'
import childDateConflictTesters from 'const/childDateConflictTesters'

const makeGetErrorsForDate = (card, boardsById, cardsById, cardStatusesById) => (
  isCardA,
  cardDates,
  testers,
) =>
  cardDates.reduce((acc, cardDate) => {
    if (
      !cardsById[cardDate.id]?.isArchived &&
      !cardsById[cardDate.id]?.isTemplate &&
      !boardsById[cardsById[cardDate.id]?.boardId]?.isClosed &&
      cardStatusesById[cardsById[cardDate.id]?.statusId]?.role !== undefined &&
      cardStatusesById[cardsById[cardDate.id]?.statusId]?.role !== CardStatusRoles.NONE &&
      cardStatusesById[cardsById[cardDate.id]?.statusId]?.role !== CardStatusRoles.COMPLETED
    ) {
      let relationError

      testers.forEach(conflictTester => {
        const error = conflictTester.test(
          isCardA ? card : cardDate,
          isCardA ? cardDate : card,
        )

        if (error) {
          if (!relationError) relationError = acc.find(relationError => relationError.cardId === cardDate.id && relationError.relationType === error.relationType)

          if (!relationError) {
            relationError = {
              cardId: cardDate.id,
              relationType: error.relationType,
              errors: [],
            }

            if (error.relationType === 'sequence') {
              relationError.prevId = isCardA ? card.id : cardDate.id
              relationError.nextId = isCardA ? cardDate.id : card.id
            } else if (error.relationType === 'child') {
              relationError.parentId = isCardA ? card.id : cardDate.id
              relationError.childId = isCardA ? cardDate.id : card.id
            }

            acc.push(relationError)
          }

          relationError.errors.push(error)
        }
      })
    }

    return acc
  }, [])

const createCardDateConflictsSelector = () => {
  return createSelector<any, any, any, any>(
    [
      (_, { cardId }) => cardId,
      (state, { cardId }) => state['view-board'].cards[cardId].isArchived,
      (state, { cardId }) => state['view-board'].cards[cardId].isTemplate,
      (_, { startDate }) => startDate,
      (_, { dueDate }) => dueDate,
      (state, { cardId }) => state['view-board'].cards[cardId].ancestorCardsDates,
      (state, { cardId }) => state['view-board'].cards[cardId].descendantCardsDates,
      (state, { cardId }) => state['view-board'].cards[cardId].prevCardDates,
      (state, { cardId }) => state['view-board'].cards[cardId].nextCardDates,
      (state) => state['view-board'].view,
      (state) => state['view-board'].cards,
      (state) => state['view-board'].cardStatuses.byId,
    ],
    (
      id,
      isArchived,
      isTemplate,
      startDate,
      dueDate,
      ancestorCardsDates,
      descendantCardsDates,
      prevCardDates,
      nextCardDates,
      boardsById,
      cardsById,
      cardStatusesById,
    ) => {
      if (
        isArchived ||
        isTemplate ||
        boardsById[cardsById[id].boardId]?.isClosed || 
        cardStatusesById[cardsById[id]?.statusId]?.role === CardStatusRoles.NONE ||
        cardStatusesById[cardsById[id]?.statusId]?.role === CardStatusRoles.COMPLETED
      ) {
        return []
      }

      const getErrorsForDate = makeGetErrorsForDate({ id, startDate, dueDate }, boardsById, cardsById, cardStatusesById)

      return [
        ...getErrorsForDate(
          false,
          prevCardDates,
          sequenceDateConflictTesters,
        ),
        ...getErrorsForDate(
          true,
          nextCardDates,
          sequenceDateConflictTesters,
        ),
        ...getErrorsForDate(
          false,
          ancestorCardsDates,
          childDateConflictTesters,
        ),
        ...getErrorsForDate(
          true,
          descendantCardsDates,
          childDateConflictTesters,
        ),
      ]
    }
  )
}

export default createCardDateConflictsSelector
